import React, { useEffect, useState } from "react";
import { Box, Button, Link, Card as MuiCard } from "@alpha/ui-lib/ui/external";
import { makeStyles } from "@alpha/ui-lib/theme";
import { faArrowRight, faChevronDown, faChevronUp, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from "@alpha/ui-lib/ui/Typography";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import MigrationCentreService from "services/MigrationCentre/migrationCentre.service";
import useAlphaSnackbar from "hooks/useAlphaSnackbar";
import useLog from "hooks/useLog";
import { TMigrationFaqsResponse } from "models/migrationCentre";
import { useTranslation } from "react-i18next";
import Markdown from 'react-markdown'

const Card = MuiCard as React.FC<React.ComponentProps<typeof MuiCard>>;

export const useStyles = makeStyles(
  () => ({
    faq: {
      padding: '16px',
      overflow: 'hidden',
      minWidth: 0,
    },
    accordionContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      marginTop: '16px',
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: '0px',
        height: '48px',
      },
      '& .MuiAccordion-root.Mui-expanded': {
        margin: '0px',
      }
    },
    }),
    { name: 'FAQ' },
  );

const FAQ: React.FC = () => {
  const classes = useStyles();
  const sb = useAlphaSnackbar();
  const { logError } = useLog();
  const [faqs, setFaqs] = useState<TMigrationFaqsResponse>([]);
  const { t } = useTranslation();

  async function getMigrationFaqs() {
    try {
      const faqs = await MigrationCentreService.getMigrationFaqs();
      const sortedFaqs = faqs.sort((a, b) => {
        const aIdNum = parseInt(a.id, 10);
        const bIdNum = parseInt(b.id, 10);
        if (!isNaN(aIdNum) && !isNaN(bIdNum)) {
          return aIdNum - bIdNum;
        }
        return a.id.localeCompare(b.id);
      });
      setFaqs(sortedFaqs);
    } catch (e) {
      sb.trigger(e.response?.data?.error || 'ERROR');
      console.error({ action: 'Error getting migration FAQs.' });
    }
  }

  useEffect(() => {
    getMigrationFaqs();
  }, []);

  return (
    <>
    <Card className={classes.faq}>
      <Typography variant="h3">{t('migration_faqs')}</Typography>
        <div>{t('find_answers_to_common_questions_about_the_migration_to_corpay')}</div>
      <Box className={classes.accordionContainer}>
      {faqs.map((faq) => {
        const markdown = (<Markdown>{faq.description}</Markdown>);
        return (
        <>
          <Accordion key={faq.title} sx={{ border: '1px solid #EAEAEA', borderRadius: '5px', boxShadow: 'none' }}>
            <AccordionSummary
              key={faq.title}
              expandIcon={<FontAwesomeIcon icon={faChevronDown as IconProp} />}
            >
              <Typography variant="body1" style={{ fontWeight: 600, color: '#1E8777' }}>{faq.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{markdown}</Typography>
            </AccordionDetails>
          </Accordion>
        </>
      )})}
      </Box>
    </Card>
    </>
  )
}

export default FAQ;